<div class="flex flex-col flex-grow justify-between min-h-screen bg-light-blue">
  <!-- Filter Panel -->
  <div class="filter-container bg-light-blue relative ml-[80px] pt-5 flex flex-col" *ngIf="hasRole(Role.CorporateAccountManager)">

    <!-- Welcome Info Block (only show when no division is selected)-->
    <ng-container *ngIf="selectedDivision == ''">
      <div class="welcome-message-block neptune-info-block mx-8 mt-4">
          <div class="message-text neptune-info-block-text">
            <span class="font-bold text-neptune-xl mb-1">Welcome {{userDisplayName}}!</span>
            <span>We're glad to have you here. To get started, please select the division you'd like to explore, this will help us show you the most relevant data.</span>
          </div>
        </div>
    </ng-container>

    <!-- Division & Dataview Selection Buttons -->
    <div class="division-dataview-select-container flex flex-col drop-shadow-md mx-8">
        <div class="neptune-filter-title filter-title py-6">Division</div>

        <div class="division-select-text flex gap-2 items-center pb-3" *ngIf="selectedDivision == ''">
          <img src="/assets/shared-icons/neptune-icon-action.svg" alt="action-icon" />
          <span class="text-blue text-sm font-normal leading-5">Click a division below to get started</span>
        </div>

        <div class="division-select-container">
          <div id="division-select-box" class="neptune-division-select border-solid border-[2px] border-blue">
            <label
              *ngFor="let division of divisions"
              class="neptune-division-option border-0 border-r-1 border-solid border-sky-blue"
              [class.selected]="division === selectedDivision"
              [for]="division.toLowerCase() + '-select-button'"
            >
              <input
                type="radio"
                name="divisionSelection"
                [id]="division.toLowerCase() + '-select-button'"
                [value]="division"
                [checked]="division === selectedDivision"
                (change)="onDivDataViewChangeButton(division, selectedDataView)"
                class="neptune-division-radio rounded-[50%] border-solid border-[2px] border-neptune-default"
              />
              {{ division }}
            </label>
          </div>

          <div class="empty-state flex flex-col items-center justify-center text-center my-6 p-6 pb-12 bg-white" *ngIf="selectedDivision == ''">
            <!-- Icon -->
            <div class="mb-4">
              <div class="w-14 h-14 flex items-center justify-center rounded-full bg-light-blue mx-auto">
                <img src="/assets/shared-icons/neptune-division-icon.svg" alt="division-icon" class="w-6 h-6" />
              </div>
            </div>

            <!-- Title -->
            <h2 class="heading text-xl !font-normal text-neptune-default !mb-3 !leading-5">
              No Division selected yet
            </h2>

            <!-- Description -->
            <p class="sub-text text-base text-neptune-color-fg-muted mb-4">
              Pick one of the divisions above to view your filtered dashboard data
            </p>

            <div class="select-text flex items-center gap-2 text-blue text-sm font-normal">
              <img src="/assets/shared-icons/neptune-blue-arrow-up.svg" alt="arrow-up" class="w-4 h-4" />
              <span>Select a division to continue</span>
            </div>
          </div>

        </div>

    </div>

    <!-- Division specific filter panel (shows up only after division is selected)-->
    <ng-container *ngIf="selectedDivision != ''">
        <div class="filter-select-container">
          <div *ngIf="selectedDivision === 'Institutional' && selectedDataView === 'Contract'">
            <app-generic-filter #filterPanel [filterOptions]="filterOptions!" [acctNumLevel]="2" (hideProceedWithSelectionButton)="onHideProceedWithSelectionButtonChange($event)"></app-generic-filter>
          </div>
          <div *ngIf="selectedDivision === 'QSR'">
            <app-generic-filter #filterPanel [filterOptions]="filterOptions!" [acctNumLevel]="2" (hideProceedWithSelectionButton)="onHideProceedWithSelectionButtonChange($event)"></app-generic-filter>
          </div>
          <div *ngIf="selectedDivision === 'Distributor'">
            <app-generic-filter #filterPanel [filterOptions]="filterOptions!" [acctNumLevel]="0" (hideProceedWithSelectionButton)="onHideProceedWithSelectionButtonChange($event)"></app-generic-filter>
          </div>
          <div *ngIf="selectedDivision === 'Pest'">
            <app-generic-filter #filterPanel [filterOptions]="filterOptions!" [acctNumLevel]="2" (hideProceedWithSelectionButton)="onHideProceedWithSelectionButtonChange($event)"></app-generic-filter>
          </div>
          <div *ngIf="selectedDivision === 'FRS'">
            <app-generic-filter #filterPanel [filterOptions]="filterOptions!" [acctNumLevel]="2" (hideProceedWithSelectionButton)="onHideProceedWithSelectionButtonChange($event)"></app-generic-filter>
          </div>
        </div>
    </ng-container>

  </div>

  <!-- Apply button thats always visible (uses filterPanel ViewChild reference to trigger apply options)-->
  <div class="apply-button-container neptune-page-bottom-container relative justify-end bg-white">
    <button
      class="apply-filter-button neptune-button-blue"
      [disabled]="disableApplyButton"
      (click)="applyFilters()"
      [ngClass]="{ 'opacity-50 cursor-not-allowed': disableApplyButton }"
    >
      <span>
        Proceed with Selection
      </span>
      <img src="/assets/chevron-right-white.svg" alt="arrow-right-icon" />
    </button>
  </div>
</div>
